var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIg = function SvgIg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0043 13.619H20.9958C16.9283 13.619 13.6191 16.9282 13.6191 20.9957V31.0042C13.6191 35.0717 16.9283 38.3809 20.9958 38.3809H31.0043C35.0719 38.3809 38.381 35.0717 38.381 31.0042V20.9957C38.381 16.9282 35.0718 13.619 31.0043 13.619ZM35.89 31.0042C35.89 33.7025 33.7026 35.8899 31.0043 35.8899H20.9958C18.2976 35.8899 16.1102 33.7025 16.1102 31.0042V20.9957C16.1102 18.2974 18.2976 16.1101 20.9958 16.1101H31.0043C33.7026 16.1101 35.89 18.2974 35.89 20.9957V31.0042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 19.5956C22.4687 19.5956 19.5957 22.4686 19.5957 25.9999C19.5957 29.5312 22.4687 32.4042 26 32.4042C29.5314 32.4042 32.4043 29.5312 32.4043 25.9999C32.4043 22.4686 29.5314 19.5956 26 19.5956ZM26 29.9132C23.8388 29.9132 22.0867 28.1612 22.0867 26C22.0867 23.8387 23.8388 22.0867 26 22.0867C28.1613 22.0867 29.9133 23.8387 29.9133 26C29.9133 28.1612 28.1612 29.9132 26 29.9132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4168 21.1783C33.2643 21.1783 33.9514 20.4913 33.9514 19.6437C33.9514 18.7962 33.2643 18.1091 32.4168 18.1091C31.5693 18.1091 30.8822 18.7962 30.8822 19.6437C30.8822 20.4913 31.5693 21.1783 32.4168 21.1783Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.7619,
    height: 24.7619,
    fill: "white",
    transform: "translate(13.6191 13.619)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ig.68a3daa11b8a671baa598ab70665e418.svg";